import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import * as d3 from 'd3'
import * as _ from 'lodash'

import Data from './Data'
import PropTypes from 'prop-types'
import MakeShiftDrawer from './MakeShiftDrawer'
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import * as utils from '../../utils/commonLayout'
import { OTHER, REDISCOVER_GENRE } from '../../constants/commons'

export default class Dashboard extends Component {
  static propTypes = {
    entities: PropTypes.object,
    genreDemo: PropTypes.object,
    demoSummary: PropTypes.object,
    selectedNetwork: PropTypes.string,
    fetchNetworkEntities: PropTypes.func.isRequired,
    setRediscoverSelectedGenre: PropTypes.func.isRequired,
    setRediscoverSelectedGenreNetwork: PropTypes.func.isRequired,
    fetchGenreDemo: PropTypes.func.isRequired,
    fetchGenreDemoSummary: PropTypes.func.isRequired
  }

  constructor (props){
    super(props)
    this.state = {
        data: null,
        isOpen: true,
        layout: null,
        config: { responsive: true, displaylogo: false},
        width: window.innerWidth,
        selectedGenre: '',
        genres: [],
        networksByVolume: [],
        networksByEngagement: []
    }
    window.addEventListener('resize', this.handleResize)
  }

  componentDidMount () {
    this.setData()
    this.handleResize()
    this.setGenres()
    if (this.state.width < 767) {
      this.setState({
        isOpen: false
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.selectedNetwork !== this.props.selectedNetwork) {
      this.setGenres()
    }

    if (prevState.selectedGenre !== this.state.selectedGenre || (prevProps.selectedNetwork !== this.props.selectedNetwork && this.state.data)) {
      let selectedGenres = this.state.data.filter(g => g['topline_genre'] === this.state.selectedGenre && (g.topicSubType === 'Show' || g.topicSubType === 'Movie'|| g.topicSubType === 'Podcast'))
      let genreEntityIds = selectedGenres.map(g => g['id'])
      let networksByAlignments = selectedGenres.map(item => ({ name: item['networks'], score: parseInt(item['num_alignments'])}))
      let totalAlignmentsCount = networksByAlignments.reduce((total, gen) => total + gen.score, 0)
      let networkList = _(networksByAlignments)
      .groupBy('name')
      .map((g, name) => ({name, score: _.sumBy(g, 'score'), percentage: (_.sumBy(g, 'score') / totalAlignmentsCount) * 100, isSelected: name === this.props.selectedNetwork })).orderBy('score', 'desc')
      .value()
      this.setState({ networksByEngagement: networkList})

      let networksByVolume = selectedGenres.map(item => ({ name: item['networks'], count: 1}))
      let totalVolume = networksByVolume.reduce((total, gen) => total + gen.count, 0)
      let networkVoulmeList = _(networksByVolume)
      .groupBy('name')
      .map((g, name) => ({name, count: _.sumBy(g, 'count'), percentage: (_.sumBy(g, 'count') / totalVolume) * 100, isSelected: name === this.props.selectedNetwork })).orderBy('count', 'desc')
      .value()
      this.setState({ networksByVolume: networkVoulmeList })
      this.props.fetchGenreDemoSummary(this.state.selectedGenre, genreEntityIds)
    }
  }

  handleResize = () => {
    this.setState({
      width: window.innerWidth
    })
    if (this.state.width < 767) {
      this.setState({
        isOpen: false
      })
    }
  }

  setGenres = () => {
    d3.csv('/data/projections_with_metadata_final.csv')
    .then(data => {
      let genreData = data.filter(g => g['networks'] === this.props.selectedNetwork && REDISCOVER_GENRE.indexOf(g['topline_genre']) > -1)
      let genres = genreData.map(item => ({ name: item['topline_genre'], score: item['topline_genre'] === OTHER ? 0 : parseInt(item['num_alignments'])}))
      let genreList = _(genres)
      .groupBy('name')
      .map((g, name) => ({name, score: _.sumBy(g, 'score')})).orderBy('score', 'desc')
      .value()
      var excludeGenres = REDISCOVER_GENRE.split(',').filter(element => genreList.map(e => e.name).indexOf(element) < 0)
      excludeGenres.map(e => {
        genreList.push({
          name: e,
          score: -1
        })
      })
      this.setState({
        data: data,
        genres: genreList
      })
    })
  }

  setData = () => {
    this.setState({
      layout: {
        width: this.state.width,
        height: window.innerHeight - 110,
        autosize: true,
        margin: {l: 10, r: 10, b: 30, t: 40},
        hovermode: 'closest',
        hoverlabel: { bgcolor: '#FFF' },
        legend: {orientation: 'h', y: -0.3},
        xaxis: {
          showgrid: true,
          zeroline: false,
          visible: false,
          automargin: true
        },
        yaxis: {
          showgrid: true,
          zeroline: false,
          visible: false,
          automargin: true
        },
        template: utils.template_plotly
      }
    })
  }

  toggleDrawer = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleSelectedGenre = (selectedGenre) => {
    this.setState({ selectedGenre: selectedGenre })
    this.props.setRediscoverSelectedGenre (selectedGenre)
  }

  render () {
    const {isOpen} = this.state
    const screenWidth = this.state.width
    return ((this.state.layout) &&
      <Card className="rediscoverWrapper position-relative" style={{background: '#e5ecf6'}}>
        <Box className={isOpen ? 'lg-70': 'w-100'} id='rediscoverLeft'>
          <Data mapWidth={this.state.width}
            selectedNetwork={this.props.selectedNetwork}
            selectedGenre={this.state.selectedGenre}
            isOpen={isOpen}
          />
        </Box>
        <Box className="w-25">
          <Box className={'viewDrawer d-flex align-items-center ' + (isOpen ? 'drawerXS' : 'drawerBlank')} id='rediscoverRight'>
            <Box className="drawerAction d-flex align-items-center justify-content-center" onClick={this.toggleDrawer}>
              {isOpen ? <ArrowRightIcon /> : <ArrowLeftIcon />}
            </Box>
            <MakeShiftDrawer
              data={this.state.data}
              open={isOpen}
              genres={this.state.genres}
              entities={this.props.entities}
              genreDemo={this.props.genreDemo}
              demoSummary={this.props.demoSummary}
              selectedNetwork={this.props.selectedNetwork}
              networksByVolume={this.state.networksByVolume}
              networksByEngagement={this.state.networksByEngagement}
              fetchNetworkEntities={this.props.fetchNetworkEntities}
              fetchGenreDemo={this.props.fetchGenreDemo}
              fetchGenreDemoSummary={this.props.fetchGenreDemoSummary}
              handleSelectedGenre={this.handleSelectedGenre}
              screenWidth={screenWidth}
              setRediscoverSelectedGenreNetwork={this.props.setRediscoverSelectedGenreNetwork}
          />
          </Box>
        </Box>
      </Card>
    )
  }
}
